<template>
  <div class="listing-banner-subscription">
    <div
      v-if="!showSuccess"
      class="top"
    >
      <ui-image
        src="https://static2.tripster.ru/img/commonComponents/subscriptionBlock/subscribe_banner_redesign.jpg"
        alt=""
        loading="lazy"
        fit="cover"
        decoding="async"
      />
    </div>
    <div class="banner-subscription">
      <div
        v-if="!showSuccess"
        class="text_wrapper"
      >
        <b>{{ title }}</b>
        <span class="text">
          {{ description }}
          <a
            class="blue-link"
            href="https://cdn.tripster.ru/email_examples/subscriptionEmailExample.html"
            rel="nofollow"
            target="_blank"
          >
            пример письма</a
          >💎
        </span>
      </div>

      <subscribe-form
        context="listing:factoid"
        mode="vertical"
        source="factoidCard"
        @submit="handleFormSubmit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { SubscribeForm } from '@experience/subscription-block-package';
  import { useI18n } from '@experience/i18n';
  import { UiImage } from '@experience/core-image-ui';
  import ru from '../i18n/ru.json';
  import { trackEvent } from '@/entities/sogu';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  interface Props {
    defaultSoguFields: ContextGeoSubject;
  }

  const props = defineProps<Props>();

  const title = computed(() => t('subcription.title'));
  const description = computed(() => t('subcription.description'));

  const showSuccess = ref(false);

  const getFactoidCardEventParams = computed(() => ({ ...props.defaultSoguFields.soguStamp, page_type: 'listing' }));
  const handleFormSubmit = (email: string) => {
    trackEvent('listing:factoid_card.request', { ...getFactoidCardEventParams.value, email });
  };
</script>

<style lang="scss">
  @use '@experience/design-tokens/typography' as typography;
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  // Корневой контейнер подписки сохраняет карточную высоту и растет по содержимому формы.
  /* stylelint-disable-next-line order/order -- Директива сохраняет обязательный для SCSS порядок @use перед правилами. */
  .listing-banner-subscription {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    height: auto !important;
    min-height: 100%;
    border-radius: 12px;
    background: var(--alias-color-background-subtle);
    color: var(--alias-color-text-default);

    @include adaptivity.mobile {
      width: unset !important;
      margin: 0 -20px;
    }
  }

  .top {
    padding: 3px 3px 0;

    // пока не трогаем, ждем отмашки от дизайнеров
    /* stylelint-disable-next-line color-no-hex */
    background: #e4d9fc;
    aspect-ratio: 2.2 / 1;

    img {
      display: block;
      width: 100%;
    }

    @include adaptivity.mobile {
      padding: 0;
    }
  }

  .banner-subscription {
    padding: 16px 20px;

    &:has(.success) {
      margin: auto;
    }
  }

  .text_wrapper {
    margin: 0 0 16px;

    @include typography.base-400-400-regular;
  }
</style>
